import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_heading_with_icon = _resolveComponent("heading-with-icon")
  const _component_skeleton_featured_slide = _resolveComponent("skeleton-featured-slide")
  const _component_base_slider = _resolveComponent("base-slider")

  return (_openBlock(), _createElementBlock("div", null, [
    ($options.featuredProjectCategoriesEnabled)
      ? (_openBlock(), _createBlock(_component_heading_with_icon, {
          key: 0,
          tag: "h2",
          "icon-name": "fire",
          "icon-namespace": "ga",
          class: "_pb-1"
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.Resources.Homepage.FeaturedSectionTitle), 1 /* TEXT */)
          ]),
          _: 1 /* STABLE */
        }))
      : _createCommentVNode("v-if", true),
    _createVNode(_component_base_slider, {
      items: $options.slides,
      "extra-large-screen-visible-items-count": 1,
      "large-screen-visible-items-count": 1,
      tags: $options.tags,
      "default-tag-key": $data.currentTagKey,
      "slide-gap-classes": "_px-2 _px-3--m",
      "scroll-container-wrapper-classes": "_pos-r _-mt-2 _-mx-2 _-mx-3--m",
      "navigation-wrapper-classes": "_shrink-0",
      "is-processing": _ctx.isProcessing,
      onTagClicked: $options.onTagClicked,
      onScrollLeft: _cache[0] || (_cache[0] = $event => ($options.onScroll('left'))),
      onScrollRight: _cache[1] || (_cache[1] = $event => ($options.onScroll('right'))),
      onViewAll: $options.onViewAll,
      onGetItems: $options.getPromotedProjects
    }, {
      prefix: _withCtx(() => [
        (!$options.featuredProjectCategoriesEnabled)
          ? (_openBlock(), _createBlock(_component_heading_with_icon, {
              key: 0,
              tag: "h3",
              "icon-name": "fire",
              "icon-namespace": "ga",
              class: "_pb-1"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.Resources.Homepage.FeaturedSectionTitle), 1 /* TEXT */)
              ]),
              _: 1 /* STABLE */
            }))
          : _createCommentVNode("v-if", true)
      ]),
      placeholder: _withCtx(() => [
        _createVNode(_component_skeleton_featured_slide)
      ]),
      _: 1 /* STABLE */
    }, 8 /* PROPS */, ["items", "tags", "default-tag-key", "is-processing", "onTagClicked", "onViewAll", "onGetItems"])
  ]))
}